export const products = [
    {
        _id: "1234wefe56",
        name: "The Lean Startup: How constant Innovation Create Radically Successful Businesses Paperback",
        price: 1899.00,
        rating: 5,
        imgUrl: "/images/book-img.png"
    },
    {
        _id: "28382863409087",
        name: "Bajaj Trio 600-Watt Mixer Grinder with 3 Jars (White/Lavender)",
        price: 3309.00,
        rating: 4,
        // imgUrl: "https://m.media-amazon.com/images/I/71E3ZJzfwAL._SL1500_.jpg"
        imgUrl: "/images/mixer-img.png"
    },
    {
        _id: "0301544769397",
        name: "Samsung Galaxy Watch4 LTE (4.4 cm, Black)",
        price: 15490.00,
        rating: 5,
        // imgUrl: "https://m.media-amazon.com/images/I/61Nhi7ovjkL._SX522_.jpg"
        imgUrl: "/images/smartWatch-img.png"
    },
    {
        _id: "979164087351132",
        name: "Infinity (Wireless Ultra Portable Mini Speaker with Mic (Black))",
        price: 899.00,
        rating: 4,
        // imgUrl: "https://m.media-amazon.com/images/I/71K6mroOBJL._SL1500_.jpg"
        imgUrl: "/images/bluetoothSpeaker-img.jpg"
    },
    {
        _id: "64085262251562",
        name: "Samsung Galaxy Tab S7 FE (12.4 inch) Large Display,Mystic (Black)",
        price: 41999.00,
        rating: 5,
        // imgUrl: "https://m.media-amazon.com/images/I/915rA4VNXuL._SL1500_.jpg"
        imgUrl: "/images/tablet-img.png"
    }

]

export const bgImage = {
    img1: "https://m.media-amazon.com/images/I/71Ih4CW2X8L._SX3000_.jpg",
    img2: "https://m.media-amazon.com/images/I/71womsFLWzL._SX3000_.png",
    img3: "https://m.media-amazon.com/images/I/71guEvd5dCL._SX3000_.jpg",
    img4: "https://m.media-amazon.com/images/I/71LbHsact9L._SX3000_.jpg"
}